import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import UploadFiles from 'components/UploadFiles';
import Literal from 'components/literal';

const CrudUploadFiles = (props) => {
    const {
        input,
        meta: { touched, error },
    } = props;

    const { onChange } = input;
    const hasError = touched && error;

    return (
        <Fragment>
            <UploadFiles onChange={onChange} value={input.value} input={input} {...props} />

            {hasError && (
                <p className="crud-error-message">
                    <Literal literal="cfm_label_required_field" />
                </p>
            )}
        </Fragment>
    );
};

CrudUploadFiles.propTypes = {
    input: PropTypes.shape({}).isRequired,
    meta: PropTypes.shape({
        touched: PropTypes.bool,
        error: PropTypes.string,
    }),
};

export default CrudUploadFiles;
